(window as any).global = window;
window.Buffer = window.Buffer ?? require('buffer').Buffer;
window.process = window.process ?? require('process');
// @ts-ignore
window.process.browser = window.process.browser ?? require("stream-browserify");

